import * as React from 'react'
import { FC } from 'react'
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined'

import { soldServiceStatusColor } from './SoldServicesCardFooter/soldServiceStatusColor'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { useTheme } from '@mui/material/styles'

interface Props {
  status: SOLD_SERVICE_STATUS
  width?: number
}

export const SoldServicesIcon: FC<Props> = (props) => {
  const { status } = props
  const color = soldServiceStatusColor(status, useTheme())
  switch (status) {
    case 'Completed':
      return (
        <CheckCircleOutlineOutlined
          style={{ color: color }}
          sx={{ width: `${props.width ?? 18}px` }}
        />
      )
    case 'Processing':
      return (
        <ReportProblemOutlined
          style={{ color: color }}
          sx={{ width: `${props.width ?? 18}px` }}
        />
      )
    case 'Submitted':
    case 'Revise':
      return (
        <InfoOutlined
          style={{ color: color }}
          sx={{ width: `${props.width ?? 18}px` }}
        />
      )
    case 'NotSent':
      return (
        <ReportProblemOutlined
          style={{ color: color }}
          sx={{ width: `${props.width ?? 18}px` }}
        />
      )
    default:
      return (
        <InfoOutlined
          style={{ color: color }}
          sx={{ width: `${props.width ?? 18}px` }}
        />
      )
  }
}
SoldServicesIcon.displayName = 'SoldServicesIcon'
